module.exports = __webpack_public_path__ + "static/media/perfilOpenToWork.043c0b72.jpg";